import { choiceDesc } from './../libs/libs.js'
const HIDEHOME = 'HIDEHOME'
const HIDECONTAINER = 'HIDECONTAINER'
const RECORDRIGHTINDEX = 'RECORDRIGHTINDEX'
const RIGHTANSWER = 'RIGHTANSWER'
const WRONGANSWER = 'WRONGANSWER'
const NOKNOW = 'NOKNOW'
const ISLOGIN = 'ISLOGIN'
const USERNAME = 'USERNAME'
const LASTVOCABULARY = 'LASTVOCABULARY'
const VOCABULARY = 'VOCABULARY'
const FIRSTCHIOSE = 'FIRSTCHIOSE'
const HIDDEN_INDUCE_PAGE = 'HIDDEN_INDUCE_PAGE'
const RESERNMAX = 'RESERNMAX'
const RESERSTART = 'RESERSTART'
const RESEREND = 'RESEREND'
const MOTIONNUM = 'MOTIONNUM'
const BOOKLIST = 'BOOKLIST'
const RESET = 'RESET'
const WRONGINDEX = 'WRONGINDEX'
// const SHOWRESULT = 'SHOWRESULT'
export default {
  // 隐藏home显示container
  [WRONGINDEX](state, str) {
    if (str != undefined) {
      state.wrongIndex = state.wrongIndex ++
    } else {
      state.wrongIndex = 0
    }
  },
  [RESET](state) {
    state.vocabulary = '0'
    state.allQuestions = '0'
    state.rightAnswer = '0'
    state.wrongAnswer = '0'
    state.firstWorng = false
    state.notKnow = '0'
    state.rightIndex = ''
    state.lastVocabulary = 0
    state.sharePage = false
    state.firstChiose = true
  },
  [HIDEHOME](state) {
    state.showHome = false
    state.showContainer = true
  },
  // 隐藏container显示result
  [HIDECONTAINER](state) {
    state.showContainer = false
    state.showResult = true
  },
  [ISLOGIN] (state, str) {
    state.isLogin = str
  },
  [FIRSTCHIOSE](state) {
    state.firstChiose = false
  },
  [VOCABULARY](state, str) {
    if ( str < 0 ) {
      state.vocabulary = 0
    } else {
      state.vocabulary = str
    }
    
  },
  [HIDDEN_INDUCE_PAGE](state, str) {
    state.sharePage = str
  },
  [LASTVOCABULARY](state, str) {
    if (str != undefined) {
      state.lastVocabulary = str
    } else {
      state.lastVocabulary = state.vocabulary
    }
    state.desc = choiceDesc(state.lastVocabulary)
  },
  [BOOKLIST](state, str) {
    state.bookList = str
  },
  [MOTIONNUM](state, str) {
    state.motionNum = str
  },
  // 记录用户用户名
  [USERNAME](state, str) {
    state.userName = str
  },
  // 记录正确答案的index
  [RECORDRIGHTINDEX](state, index){
    state.rightIndex = index
  },
  // 计数正确答案
  [RIGHTANSWER](state) {
    state.rightAnswer ++
    state.allQuestions ++
  },
  [RESERNMAX](state, str) {
    if (str == undefined) {
      if (state.vocabulary < 5000) {
        state.Nmax = 500
      } else if (state.vocabulary < 8000) {
        state.Nmax = 400
      } else if (state.vocabulary < 11000) {
        state.Nmax = 300
      } else if (state.vocabulary < 13000) {
        state.Nmax = 200
      } else {
        state.Nmax = 100
      }
    } else {
      state.Nmax = Math.floor(state.Nmax / 2)
    }
  },
  [RESERSTART](state, str) {
    state.start = str
  },
  [RESEREND](state, str) {
    state.end = str
  },
  // 计数错误答案
  [WRONGANSWER](state) {
    state.wrongAnswer ++
    state.allQuestions ++
  },
  // 计数不认识
  [NOKNOW](state) {
    state.notKnow ++
    state.allQuestions ++
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js